<!--
 * @Author: cn1994
 * @Date: 2024-09-24 13:27:40
 * @LastEditors: cn1994
 * @LastEditTime: 2025-03-07 15:04:00
 * @Description: dialog组件
-->
<template>
  <el-dialog
    :title="title"
    :visible.sync="show"
    :width="dialogWidth"
    :close-on-click-modal="false"
    class="ls-dialog-component"
    :show-close="showClose"
    :append-to-body="appendToBody"
    :custom-class="customClass"
    @close="close"
    v-dialog-close="overlayClose ? close : false"
  >
    <div class="ls-dialog-component-content">
      <slot name="content">默认内容</slot>
    </div>
    <slot name="footer">
      <div class="dialog-footer">
        <ls-button
          v-if="hasCancelBtn"
          :disabled="cancelDisabled"
          :loading="cancelLoading"
          @click="cancel"
        >
          {{ cancelText }}
        </ls-button>
        <ls-button
          v-if="hasConfirmBtn"
          type="primary"
          :disabled="confirmDisabled"
          :loading="confirmLoading"
          @click="confirm"
        >
          {{ confirmText }}
        </ls-button>
      </div>
    </slot>
  </el-dialog>
</template>

<script>

import mixin from './index.js'

export default {
  name: 'LsDialog',
  componentName: 'LsDialog',
  mixins: [mixin],
  props: {
    // 弹窗开关
    visible: {
      type: Boolean,
      default: false,
    },
    // 弹窗标题
    title: {
      type: String,
      default: '提示'
    },
    // 宽度，支持百分比和数字以及string类型的数字
    width: {
      type: [String, Number],
      default: "660",
    },
    //是否显示关闭按钮
    showClose: {
      type: Boolean,
      default: true,
    },
    // Dialog 自身是否插入至 body 元素上。嵌套的 Dialog 必须指定该属性并赋值为 true
    appendToBody: {
      type: Boolean,
      default: true,
    },
    // 自定义dialog类名
    customClass: {
      type: String,
      default: ''
    },
    //是否显示取消按钮
    hasCancelBtn: {
      type: Boolean,
      default: true,
    },
    //是否显示确定按钮
    hasConfirmBtn: {
      type: Boolean,
      default: true,
    },
    // 是否禁用取消按钮
    cancelDisabled: {
      type: Boolean,
      default: false
    },
    // 是否禁用确定按钮
    confirmDisabled: {
      type: Boolean,
      default: false
    },
    // 取消按钮loading
    cancelLoading: {
      type: Boolean,
      default: false,
    },
    // 确定按钮loading
    confirmLoading: {
      type: Boolean,
      default: false,
    },
    overlayClose: {
      //是否点遮罩层关闭
      type: Boolean,
      default: true,
    },
    cancelText: {
      type: String,
      default: '取消'
    },
    confirmText: {
      type: String,
      default: '确定'
    },
    closeFun: {
      type: Function,
      default: () => {
        this.show = false;
      }
    }
  },
  data () {
    return {

    }
  },
  computed: {
    show: {
      get() {
        return this.visible;
      },
      set(v) {
        this.$emit("update:visible", v);
      },
    },
    dialogWidth(){
      if (typeof this.width === 'number') {
        return this.width
      }

      if (typeof this.width === 'string' && this.width.includes('%')) {
        return this.width
      } else {
        return this.width + 'px'
      }
    }
  },
  methods: {
    close() {
      this.closeFun()
    },
    cancel(e) {
      this.$emit("cancel");
    },
    confirm(e) {
      this.$emit("confirm");
    },

  }
}

</script>

<style lang="less" scoped>
@import url('./index.less');
</style>